/**
 * Created by Angelika on 26.09.2017.
 */
export const cookieOptions = {expires: 14};

export const AUTH_DATA = 'authData';
export const USER_CONFIG = 'userConfig';
export const IS_SHOW_POPUP = "isShowPopup"



// WEBPACK FOOTER //
// ./src/constants/cookies.js